import { contentChild, Directive } from '@angular/core';
import { SimpleTableHeaderCellDef } from './simple-table-header-cell-def';
import { SimpleTableCellDef } from './simple-table-cell-def';

/**
 * Defines a set of cells available for a table column.
 */
@Directive({
  selector: '[fbSimpleTableColumnDef]',
})
export class SimpleTableColumnDef {
  /**
   * Defines the header cell for the column.
   */
  public readonly headerCellDef = contentChild.required(SimpleTableHeaderCellDef);

  /**
   * Defines the cell for the column.
   */
  public readonly cellDef = contentChild.required(SimpleTableCellDef);
}
